<template>
  <div class="page">
    <div class="tbs">
      <van-tabs v-model="active" type="none" @click="handleClick">
        <van-tab title="首页">
          <div slot="title" class="tab-item">
            <van-icon name="wap-home-o" />
            <span>首页</span>
          </div>
        </van-tab>
        <van-tab title="社交电商">
          <div slot="title" class="tab-item">
            <van-icon name="friends-o" />
            <span>社交电商</span>
          </div>
        </van-tab>
        <van-tab title="同城配送">
          <div slot="title" class="tab-item">
            <van-icon name="send-gift-o" />
            <span>同城配送</span>
          </div>
        </van-tab>
        <van-tab title="多级分销">
          <div slot="title" class="tab-item">
            <van-icon name="cluster-o" />
            <span>多级分销</span>
          </div>
        </van-tab>
        <van-tab title="营销工具">
          <div slot="title" class="tab-item">
            <van-icon name="apps-o" />
            <span>营销工具</span>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide part-01">
          <div class="option1">
            <div class="shop-logo">
              <img src="../assets/images/icon.png" alt="" />
            </div>
            <div class="shop-title">
              <img src="../assets/images/3.png" alt="" />
              <div class="title-itme">
                <span>分钟生成</span>
                <span>最适合你业务的小程序</span>
              </div>
            </div>
            <van-button @click="goSetShopPage" class="van-button1" round>立即开店</van-button>
            <div class="shop-ad">一套软件解决所有开店难题</div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="option2">
            <div class="part02-title">
              <div class="part02-title1">移动社交电商</div>
              <div class="part02-title2">小程序/H5（公众号）/ APP多端同步 一键生成</div>
            </div>
            <img src="../assets/images/list1.png" alt style=" margin: 20px 0 0 0" />
            <div class="part02-int">
              <p>3分钟搭建移动商城，适配各行业</p>
              <p>多端合一，全渠道海量曝光</p>
              <p>丰富的营销玩法，提升成交</p>
              <p>系统化管理客户，精准会员营销</p>
            </div>
            <van-button @click="goSetShopPage" class="van-button2" round type="info">立即开店</van-button>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="option2 bgc-color">
            <div class="part02-title">
              <div class="part02-title1">同城配送O2O</div>
              <div class="part02-title2">适用于餐饮 / 生鲜 / 烘培 / 鲜花 / 商超等行业</div>
            </div>
            <img src="../assets/images/list2.png" alt />
            <div class="part02-int">
              <p>线上线下高效连通</p>
              <p>第三方配送一键接入</p>
              <p>点餐、支付、配送、出票、一站式解决方案</p>
              <p>多种营销工具 客户精细化管理</p>
            </div>
            <van-button @click="goSetShopPage" class="van-button2" round type="info">立即开店</van-button>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="option2">
            <div class="part02-title">
              <div class="part02-title1">多级分销</div>
              <div class="part02-title2">自主可控高效铺设销售渠道</div>
            </div>
            <img src="../assets/images/list3.png" alt />
            <div class="part04-int">
              <div class="part02-int1">
                <p>一键分销，快速裂变</p>
                <p>系统自动结算佣金</p>
              </div>
              <div class="part02-int2">
                <p>支持佣金等级设置</p>
                <p>分销效果实时监控</p>
              </div>
            </div>
            <van-button @click="goSetShopPage" class="van-button2" round type="info">立即开店</van-button>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="option2 bgc-color">
            <div class="part02-title">
              <div class="part02-title1">多种营销活动工具</div>
              <div class="part02-title2">快速裂变传播 强势吸粉 订单指数增长</div>
            </div>
            <img src="../assets/images/list4.png" alt />
            <div class="part02-int">
              <p>拼团、砍价、秒杀、优惠券、会员卡、分销等</p>
              <p>多种功能组合玩法</p>
              <p>支持佣金等级设置</p>
              <p>分销效果实时监控</p>
            </div>
            <!-- <van-button
              @click="goSetShopPage"
              class="van-button2"
              round
              type="info"
              >立即开店</van-button
            >-->
            <van-button @click="goSetShopPage" class="van-button3" type="info">立即创建店铺</van-button>
          </div>
        </div>
      </div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  // name: 'HelloWorld',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      active: 0,
      swiper: null,
      b: 0,
    }
  },
  mounted() {
    let _this = this
    _this.swiper = new Swiper('.swiper-container', {
      direction: 'vertical',
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      on: {
        touchMove: function(event) {
          // console.log(event);
        },
        slideChangeTransitionStart: function() {
          // alert(this.activeIndex);
          // console.log(this.activeIndex);
          // console.log(this);
          _this.active = this.activeIndex
        }
      }
    })
  },
  methods: {
    goSetShopPage() {
      this.$router.push({
        name: 'login'
      })
    },
    handleClick(name, title) {
      switch (name) {
        case 0:
          this.swiper.slideTo(0, 1000)
          break
        case 1:
          this.swiper.slideTo(1, 1000)
          break
        case 2:
          this.swiper.slideTo(2, 1000)
          break
        case 3:
          this.swiper.slideTo(3, 1000)
          break
        case 4:
          this.swiper.slideTo(4, 1000)
          break
      }
    }
  }
}
</script>

<style lang="css" scoped>
.tbs {
  width: 100%;
  /* height: 100%; */
  position: fixed;
  top: 0;
  z-index: 99;
  /* padding: 0 20px; */
}
.page {
  height: 100%;
}

.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.tab-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.part-01 {
  background: url(../assets/images/list0.jpg) no-repeat center;
}
.option1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: 65px;
  box-sizing: border-box;
  background: linear-gradient(
    135deg,
    rgba(17, 62, 195, 1),
    rgba(15, 67, 177, 0.4)
  );
}
.shop-logo > img {
  width: 135px;
  height: 42px;
  margin-top: 20px;
}
.shop-title {
  display: flex;
  margin-top: 70px;
}
.shop-title > img {
  width: 70px;
  height: 98px;
}
.title-itme {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 12px;
}
.title-itme span:first-child {
  font-size: 45px;
  color: #fff;
  margin-top: 10px;
}
.title-itme span:last-child {
  font-size: 18px;
  color: #fff;
}
.van-button1 {
  width: 160px;
  height: 49px;
  margin-top: 132.5px;
  color: #1258cb;
  /* font-weight: 600; */
  font-size: 16px;
}
.shop-ad {
  margin-top: 20px;
  font-size: 18px;
  color: #fff;
}
.option2 {
  width: 100%;
  height: 100%;
  /* background-color: #333; */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding: 60px 0 0 0;
  font-size: 16px;
  box-sizing: border-box;
  position: relative;
}
.bgc-color {
  background: #f8f8f8;
}
.option2 > img {
  margin: 20px 0 30px 0;
  width: 261px;
  display: block;
  /* height: 226px; */
}
.part02-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-top: 50px; */
}
.part02-title1 {
  margin-bottom: 16px;
  font-size: 24px;
}
.part02-int {
  width: 100%;
  height: 125px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
}
.part02-int p {
  margin: 0;
  padding: 0;
}
.van-button2 {
  width: 160px;
  height: 49px;
  margin-top: 38px;
  /* margin-left: 117.5px; */
  /* font-weight: 600; */
  font-size: 16px;
}
.part02-int1,
.part02-int2 {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.part04-int {
  width: 100%;
  /* background-color: #999; */
}
.van-button3 {
  width: 100%;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  z-index: 999;
}
.van-icon {
  /* margin-top: 3px; */
  font-size: 16px;
  margin-right: 3px;
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
</style>
